/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *
 *******************************************************************************/

import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withStyles } from '@mui/styles'
import Home from '../../../components/Views/public/Home'

const styles = theme => ({
  paper: {
      background: 'rgba(0, 0, 0, 0.5)',
  },
})

class HomePage extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);

  }
  render() {
    return (
      <>
      <Home />
      </>
    )
  }
}

HomePage.propTypes = {
  classes: PropTypes.object.isRequired,
}

function mapStateToProps() {
  return {}
}

const styledHomePage = withStyles(styles)(HomePage)
const connectedHomePage = connect(mapStateToProps)(styledHomePage)
export { connectedHomePage as HomePage }
